import React from 'react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { AppImage } from '../AppImage';
import { processSteps } from '../../data/process';
export function Process() {
  return <Section labelledBy="process-title" bordered data-id="element-555" data-mp="2gg3bivv13dib">
      <Container data-id="element-556" data-mp="2lh0uhanv4bkv">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-8" data-id="element-557" data-mp="2lhiwknx7hk0p">
          <div className="lg:col-span-4" data-id="element-558" data-mp="2qfkjxl1o05hz">
            <div className="lg:sticky lg:top-[112px]" data-id="element-559" data-mp="2qesuyt2kp60o">
              <Reveal data-id="element-560" data-mp="2ugxnfohabwlq">
                <h2 id="process-title" className="max-w-[14ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-561" data-mp="2uge36145ww4j">
                  The process, written down.
                </h2>
                <p className="mt-6 max-w-[38ch] text-body text-muted" data-id="element-562" data-mp="348tmb1r73qr0">
                  You get your schedule on day one, with the review windows already in your
                  calendar. A Starter runs about three weeks, a Standard three to four. Nothing
                  about the timeline is a surprise.
                </p>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-7 lg:col-start-6" data-id="element-563" data-mp="2z8shpjmqyqm4">
            <ol className="border-t border-hairline" data-id="element-564" data-mp="2ua8w5kc2fgua">
              {processSteps.map((step, index) => <Reveal as="li" key={step.index} delay={index * 0.06} data-id="element-565" data-mp="2qagt1n5fy2wb" data-mpi={index}>
                  <div className="grid gap-6 border-b border-hairline py-10 md:grid-cols-12 md:gap-8" data-id="element-566" data-mp="3mzemn21gfurw">
                    <div className="md:col-span-2" data-id="element-567" data-mp="3i036nv8wwtbd">
                      <p className="text-small tabular-nums text-muted" data-id="element-568" data-mp="3i1d4qkfrm1i0">{step.index}</p>
                      <p className="mt-1 text-small font-medium text-ink" data-id="element-569" data-mp="3d8bpucfk61yf">{step.label}</p>
                    </div>
                    <div className="md:col-span-6" data-id="element-570" data-mp="3966yjkcl1hey">
                      <h3 className="text-[24px] leading-[1.3] tracking-[-0.02em] text-ink" data-id="element-571" data-mp="9l1j0jgsn1gw">
                        {step.name}
                      </h3>
                      <p className="mt-3 max-w-measure text-body text-muted" data-id="element-572" data-mp="4s8h03cpm78i">{step.description}</p>
                      <ul className="mt-5 flex flex-wrap gap-2" data-id="element-573" data-mp="1z49kqpr7nnkm">
                        {step.deliverables.map(deliverable => <li key={deliverable} className="rounded-card border border-hairline px-3 py-1.5 text-small text-muted" data-id="element-574" data-mp="1pcn9wuisbqie">
                            {deliverable}
                          </li>)}
                      </ul>
                    </div>
                    <AppImage src={step.image} alt={step.alt} ratio="4:3" className="md:col-span-4 md:self-start" data-id="element-575" data-mp="1l85v79ra83eh" />
                  </div>
                </Reveal>)}
            </ol>
          </div>
        </div>
      </Container>
    </Section>;
}